$(".c-accordion__title").click(function (){

  $(this).parent().toggleClass("on");

});
